export default __webpack_public_path__ + "static/media/arrow-top.e220cd54.svg";